import { proteinAPI } from '../api/protein';
import { actionWrapper } from './actionWrapper';

export const SET_PROTEINS = 'SET_PROTEINS';

export const getProteins = () => actionWrapper(async () => {
  const proteinsData = await proteinAPI.getProteins();

  return {
    type: SET_PROTEINS,
    payload: proteinsData,
  };
});